import axios from 'axios';
import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const CSRF_KEY = 'mp_conv_csrf';

// Instância dedicada às conversas: envia o cookie de sessão (HttpOnly) e o CSRF.
const convApi = axios.create({
  baseURL: `${API_URL}/api/marketplace/conversas`,
  timeout: 30000,
  withCredentials: true,
});

export const setCsrf = (token) => {
  try { if (token) sessionStorage.setItem(CSRF_KEY, token); } catch (_) {}
};
export const getCsrf = () => {
  try { return sessionStorage.getItem(CSRF_KEY) || ''; } catch (_) { return ''; }
};
export const clearCsrf = () => {
  try { sessionStorage.removeItem(CSRF_KEY); } catch (_) {}
};

convApi.interceptors.request.use((config) => {
  const token = getCsrf();
  if (token) config.headers['X-Conv-Csrf'] = token;
  return config;
});

export const newClientMsgId = () => {
  try { return crypto.randomUUID(); } catch (_) { return `m-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`; }
};

export const conversationsEnabled = async () => {
  try {
    const res = await convApi.get('/estado');
    return !!res.data?.ativo;
  } catch (_) { return false; }
};

export const useConversationsEnabled = () => {
  const [ativo, setAtivo] = useState(false);
  useEffect(() => {
    let alive = true;
    conversationsEnabled().then((v) => { if (alive) setAtivo(v); });
    return () => { alive = false; };
  }, []);
  return ativo;
};

export default convApi;
